import { flatten } from 'lodash'

export const toArray = <T>(children: T) =>
  Array.isArray(children) ? flatten(children.filter(Boolean)) : [children].filter(Boolean)
